import { useShadowDOM } from '@astrumu/core-ui-shadow-dom';
export const useStylesheetAttachment = (stylesheet) => {
    const { isShadowDOM, shadowStylesInsertionPoint } = useShadowDOM();
    const options = isShadowDOM ? { target: shadowStylesInsertionPoint } : {};
    if (stylesheet) {
        stylesheet.use(options);
    }
};
//# sourceMappingURL=index.js.map